import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorService } from 'src/app/shared/services/errors.service';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import Swal from 'sweetalert2';
import * as moment from 'moment';

class updateMitigation{
  id : number;
  description : string;
  calification : string;
  action_date : string;
  mitigation_deadline_date : string;
  users_id : number;
  risks_matrix_id : number;
  username : string;
}

@Component({
  selector: 'app-risk-mitigations-update',
  templateUrl: './risk-mitigations-update.component.html',
  styleUrls: ['./risk-mitigations-update.component.scss']
})
export class RiskMitigationsUpdateComponent implements OnInit {

  idMitigation:number;
  idProject : number;
  idMatrix : number;

  mitigationUpdateForm : FormGroup;

  listAssigned: any[] = [];
  listCalification : any[] = [];

  updateMitigation : updateMitigation;

  constructor(
    private apiService: ApiServiceProject,
    private router : Router,
    private activatedRoute : ActivatedRoute,
    private fb : FormBuilder,
    private spinner : NgxSpinnerService,
    private errorService:ErrorService
  ) { 
    this.activatedRoute.params.subscribe(params => {
      this.idProject = params['id'];
      this.idMatrix = params ['idMatrix'];
      this.idMitigation = params['idMitigation'];
    })
  }
  ngOnInit(): void {
    this.mitigationUpdateForm = this.fb.group({
      id : [''],
      description : [''],
      calification : [''],
      action_date : [''],
      mitigation_deadline_date : [''],
      users_id : [''],
      risks_matrix_id : [''],
      username : [''],
    });

    this.spinner.show();

    this.apiService.getService(`project-view-mitigations-option?id_project=${this.idProject}`)
    .subscribe({
      next : (data:any) =>{

        if (data.code == null) {
          if (data == '' || data == null) {
            this.spinner.hide();
            Swal.fire({
              title: 'No se encontraron registros',
              text: '',
              icon: 'info',
              confirmButtonText: 'Aceptar',
              heightAuto: false
            }).then((res) =>{
              if (res.isConfirmed || res.isDismissed) {
                this.router.navigate(['home']);
              }
            })
          }
  
          this.listAssigned = data.listAssigned;
          this.listCalification = data.listCalification ;
        this.spinner.hide();
        }else{
          this.spinner.hide();
          Swal.fire({title:data.error,text: '',icon: 'error',heightAuto: false});
        }
      },error:(error)=>{
        this.errorService.error(error);
      },
    });

    let dato = JSON.parse(localStorage.getItem("info-mtn"));

          this.mitigationUpdateForm.patchValue({
            id : dato.id,
            description : dato.description,
            calification : dato.calification,
            action_date : moment(dato.dateAccion, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
            mitigation_deadline_date : moment(dato.dateMitigation, 'DD-MM-YYYY').format("YYYY-MM-DD"), 
            users_id : dato.usersId,
            risks_matrix_id : this.idMatrix,
            username : dato.username
            });

    
}

formUpdate(): void {

  this.spinner.show();

  if (this.mitigationUpdateForm.value.description === '') {
    this.spinner.hide();
    Swal.fire({title:'Debe ingresar una descripción' ,text: '',icon: 'error',heightAuto: false});
    return;
  }

  if (this.mitigationUpdateForm.value.users_id === '') {
    this.spinner.hide();
    Swal.fire({title:'Debe ingresar un responsable' ,text: '',icon: 'error',heightAuto: false});
    return;
  }
  if (this.mitigationUpdateForm.value.calification === '') {
    this.spinner.hide();
    Swal.fire({title:'Debe ingresar una clasificacion' ,text: '',icon: 'error',heightAuto: false});
    return;
  }
  if (this.mitigationUpdateForm.value.action_date === '' || this.mitigationUpdateForm.value.action_date === 'Invalid date') {
    this.spinner.hide();

    Swal.fire({title:'Debe ingresar una fecha de acción' ,text: '',icon: 'error',heightAuto: false});
    return;
  }
  if (this.mitigationUpdateForm.value.mitigation_deadline_date === '' || this.mitigationUpdateForm.value.mitigation_deadline_date === 'Invalid date') {
    this.spinner.hide();
    Swal.fire({title:'Debe ingresar una fecha limiite' ,text: '',icon: 'error',heightAuto: false});
    return;
  }

  
  this.updateMitigation = new updateMitigation();

  this.updateMitigation.id = this.mitigationUpdateForm.value.id;
  this.updateMitigation.description = this.mitigationUpdateForm.value.description;
  this.updateMitigation.calification = this.mitigationUpdateForm.value.calification;
  this.updateMitigation.action_date = moment(this.mitigationUpdateForm.value.action_date).format("DD-MM-YYYY");
  this.updateMitigation.mitigation_deadline_date = moment(this.mitigationUpdateForm.value.mitigation_deadline_date).format("DD-MM-YYYY");
  this.updateMitigation.users_id = this.mitigationUpdateForm.value.users_id;
  this.updateMitigation.risks_matrix_id = Number(this.mitigationUpdateForm.value.risks_matrix_id);
  this.updateMitigation.username = this.mitigationUpdateForm.value.username;


        this.apiService
        .putUpdate('project-view-mitigations-update',this.updateMitigation)
        .subscribe({
          next: (data:any)=>{
            if(data.message){
            this.spinner.hide();
              // this.listRisksMatrix = this.createRisk;
              Swal.fire({title:'Se ha actualizado la mitigacion correctamente' ,text: '',icon: 'success',heightAuto: false})
              .then(( ) =>[this.router.navigate(['/pdg/project/',this.idProject, this.idMatrix ,'risk','mitigations'])] );
            }else{
              this.spinner.hide();
              Swal.fire({title:data.error ,text: '',icon: 'error',heightAuto: false}).then((dato)=>{
              });
            }
    
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });

  }

}
